import React, { useEffect, useState } from "react";

const ButtonScrollTop = () => {
  const [isVisible, setIsVisible] = useState(window.pageYOffset > 600);

  useEffect(() => {
    // Function to toggle button visibility
    const toggleVisibility = () => setIsVisible(window.pageYOffset > 600);

    // Check visibility on mount in case the page is already scrolled
    toggleVisibility();

    window.addEventListener("scroll", toggleVisibility);

    // Cleanup function
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <div>
      <button
        type="button"
        id="scroll-to-top-button"
        className={`${isVisible ? "show-button" : ""}`}
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-hidden={!isVisible}
      >
        <i className="fas fa-angle-up"></i>
      </button>
    </div>
  );
};

export default ButtonScrollTop;
